import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { TrendingUp, TrendingDown, DollarSign, CreditCard, Users, ShoppingCart, Calendar, FileText, Banknote, Smartphone, CheckCircle } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { useDispatch, useSelector } from 'react-redux';
import { selectPrefix, selectShopDetails } from '../utility/Redux/profile';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import { useEffect, useState } from 'react';
import moment from 'moment';
import { BillModal } from './BillSummary';
import CryptoJS from 'crypto-js';
import { setSpinnerLoading } from '../utility/Redux/modal';
import { Button } from './ui/button';
import SpinnerLoading from '../utility/component/modals/spinnerLoading';

export default function BalanceReport({goToLedger}) {
  const [weeklySales,setWeeklySales]=useState([])
  const [todayBal,setTodayBal]=useState([])
 const [monthlySales,setMonthlySales]=useState([
 
])
const [dashboardDetails, setDashboardDetails] = useState("")
const [isDialogOpen, setIsDialogOpen] = useState(false);
const [purchaseSummary, setPurchaseSummary] = useState([])
const [itemList,setItemList]=useState([])

  
  const companyDetail = useSelector(selectShopDetails)
  const dispathc = useDispatch()
const getViewBillDetatils = (invno) => {
  const companYEmail = companyDetail.company_email
  const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;

  // const hmac = CryptoJS.HmacSHA256(message, secret);
  const hmac = CryptoJS.HmacSHA256(companYEmail, secretPass);
  // Convert the HMAC to a string and encode it using Base64
  const hmacString = hmac.toString(CryptoJS.enc.Base64);
  console.log('getViewBillDetatils2');
  dispathc(setSpinnerLoading("loading"))
  CallAPIPromise(
    '/api/reports/viewBill',

    {
      table_prefix: prefix,
      invno: invno,
      company_email: companYEmail,
    },
    hmacString,
    dispathc
  )
    .then((response) => {
      const dataList = response.data.response;
      console.log(dataList)
      setItemList(dataList);
      setIsDialogOpen(true)
      // setDate(dataList[0].DATE);
      // setBillStatus(dataList[0].BILL_STATUS);
    })
    .catch((err) => {
      console.log(err);
    })
  .finally(() => {
    dispathc(setSpinnerLoading(false));
  });
};
  const weeklyTotal = weeklySales[0]? weeklySales.reduce((sum, day) => sum + day.CASH_AMOUNT + day.BTC_AMOUNT + day.CARD_AMOUNT + day.EPAYMENT + day.CHEQUE_AMOUNT, 0):0
  const last = monthlySales[monthlySales.length - 1];

  const monthlyTotal = monthlySales.length
    ? last.CASH_AMOUNT +
      last.BTC_AMOUNT +
      last.CARD_AMOUNT +
      last.EPAYMENT +
      last.CHEQUE_AMOUNT
    : 0;
  const purchaseTotal = purchaseSummary[0]? purchaseSummary.reduce((sum, item) => sum + item.GTOTAL, 0):0
  const maxWeeklySale = weeklySales[0]? Math.max(...weeklySales.map(day => day.CASH_AMOUNT + day.BTC_AMOUNT)):0
  const todaySale = weeklySales.length
  ? weeklySales.find(w => w.DAY_NAME === moment().format("dddd"))
  : {
    "CASH_AMOUNT": 0,
    "BTC_AMOUNT": 0,
    "CARD_AMOUNT": 0,
    "EPAYMENT": 0,
    "CHEQUE_AMOUNT": 0
}

  const balanceData = {
    todaySales: todaySale?.CASH_AMOUNT+ todaySale?.BTC_AMOUNT+todaySale?.CARD_AMOUNT+todaySale?.BTC_AMOUNT+todaySale?.CHEQUE_AMOUNT+todaySale?.CHEQUE_AMOUNT || 0,
    weeklySales: weeklyTotal,
    monthlySales: monthlyTotal,
  };


  const shopDetails =useSelector(selectShopDetails)
  const prefix = useSelector(selectPrefix)
  useEffect(() => {
    CallAPIPromise("/api/shopPurchase/paymode_Current_Week_Sum", {
      table_prefix: prefix,
      ACCOUNT_NO:shopDetails?.account_no
    }).then((res) => {
      if (res?.data?.response) {
      setWeeklySales(res?.data?.response)
    }
    })

    CallAPIPromise("/api/shopBalance/partyBalance", {
      table_prefix: prefix,
      ACCOUNT_NO:shopDetails?.account_no
    }).then((res) => {
      console.log(res)

      if (res?.data?.response) {
        const data =res?.data?.response
       const bal =  data[0].OP_DEBIT +
        data[0].DEBIT -
         (data[0].OP_CREDIT + data[0].CREDIT)
        console.log(bal)
        setTodayBal(bal)
      // setWeeklySales(res?.data?.response)
    }
    })
    CallAPIPromise("/api/shopPurchase/paymode_Monthly_Sum", {
      table_prefix: prefix,
      ACCOUNT_NO:shopDetails?.account_no
    }).then((res) => {
      if (res?.data?.response) {
        setMonthlySales(res?.data?.response)
      }
     })
    CallAPIPromise("/api/shopPurchase/shopPurchaseSummary", {
      table_prefix: prefix,
      FDATE:moment().subtract(1,"week").format("YYYY/MM/DD"),
      TDATE:moment().format("YYYY/MM/DD"),
      ACCOUNT_NO:shopDetails?.account_no
  }).then((res) => {
    if (res?.data?.response) {
      setPurchaseSummary(res?.data?.response)
    }
   })
},[])

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-gray-900 mb-1">Balance Report</h2>
        <p className="text-gray-600">Overview of your shop's financial health</p>
      </div>

      {/* Main Balance Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* <Card className="bg-gradient-to-br from-blue-600 to-indigo-600 text-white border-0">
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between">
              <span>Total Balance</span>
              <DollarSign className="w-5 h-5" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-white mb-1">₹{balanceData.totalBalance.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</p>
            <div className="flex items-center gap-1 text-white/80">
              <TrendingUp className="w-4 h-4" />
              <span>+12.5% this month</span>
            </div>
          </CardContent>
        </Card> */}

        <Card onClick={() => {
          goToLedger()
}} className={"bg-gradient-to-br from-blue-600 to-indigo-600 text-white border-0"}>
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between ">
              <span>Your Today Balance</span>
              <ShoppingCart className="w-5 h-5 text-green-600" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className=" mb-1">₹{todayBal.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</p>
   
          </CardContent>
        </Card>
        <Card className={"bg-gradient-to-br from-blue-600 to-indigo-600 text-white border-0"}>
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between ">
              <span>Today's Purchase</span>
              <ShoppingCart className="w-5 h-5 text-green-600" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className=" mb-1">₹{balanceData.todaySales.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</p>
            {/* <div className="flex items-center gap-1 text-green-600">
              <span>{balanceData.todayOrders} orders</span>
            </div> */}
          </CardContent>
        </Card>

      

        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between text-gray-900">
              <span>Weekly Purchase</span>
              <Calendar className="w-5 h-5 text-purple-600" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-900 mb-1">₹{balanceData.weeklySales.toLocaleString('en-IN')}</p>
            <div className="flex items-center gap-1 text-purple-600">
              <span>Last 7 days</span>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between text-gray-900">
              <span>Monthly Purchase</span>
              <TrendingUp className="w-5 h-5 text-orange-600" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-900 mb-1">₹{balanceData.monthlySales.toLocaleString('en-IN')}</p>
            <div className="flex items-center gap-1 text-orange-600">
              <span>{last?.YEAR_MONTH} </span>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Charts Section */}
      <Tabs defaultValue="weekly" className="w-full">
        <TabsList className="grid grid-cols-2 w-full mb-3 bg-[#F3F3F5] rounded-lg p-1" >
          <TabsTrigger   className="data-[state=active]:bg-white data-[state=active]:text-blue-600 
                 data-[state=active]:shadow-sm data-[state=active]:rounded-l-md rounded-r-none transition-all duration-300 
                 border-0 " value="weekly">This Week</TabsTrigger>
          <TabsTrigger  className="data-[state=active]:bg-white data-[state=active]:text-blue-600 
      data-[state=active]:shadow-sm transition-all duration-300 
      rounded-md border-0  data-[state=active]:rounded-r-md rounded-l-none " value="monthly">Last 10 Months</TabsTrigger>
        </TabsList>
        
        <TabsContent value="weekly" className="mt-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-gray-900">This Week's Sales (₹{weeklyTotal.toLocaleString('en-IN')})</CardTitle>
            </CardHeader>
            <CardContent>
              {/* Simple Day-wise Sales */}
              <div className="space-y-3">
                {weeklySales.map((day) => {
                  const dayTotal = day.CASH_AMOUNT + day.BTC_AMOUNT + day.CARD_AMOUNT + day.EPAYMENT + day.CHEQUE_AMOUNT;
                  const percentage = maxWeeklySale > 0 ? (dayTotal / maxWeeklySale) * 100 : 0;
                  const isToday = day.DAY_NAME === moment().format("dddd"); // Current day in your data
                  
                  return (
                    <div key={day.DAY_NAME} className={`p-4 rounded-lg border-2 ${isToday ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white'}`}>
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                          <span className="text-gray-900">{day.DAY_NAME}</span>
                          {isToday && <span className="px-2 py-0.5 bg-blue-500 text-white rounded-full">Today</span>}
                        </div>
                        <span className="text-gray-900">₹{dayTotal.toLocaleString('en-IN')}</span>
                      </div>
                      
                      {/* Visual Bar */}
                      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                        <div 
                          className={`h-full rounded-full transition-all ${isToday ? 'bg-blue-500' : 'bg-blue-500'}`}
                          style={{ width: `${percentage}%` }}
                        ></div>
                      </div>
                      
                      {/* Payment breakdown if any */}
                      {dayTotal > 0 && (
                        <div className="flex gap-4 mt-2 text-gray-600">
                          {day.CASH_AMOUNT > 0 && <span>💵 Cash: ₹{day.CASH_AMOUNT.toLocaleString('en-IN')}</span>}
                          {day.BTC_AMOUNT > 0 && <span>🏦 BTC: ₹{day.BTC_AMOUNT.toLocaleString('en-IN')}</span>}
                          {day.CARD_AMOUNT > 0 && <span>💳 Card: ₹{day.CARD_AMOUNT.toLocaleString('en-IN')}</span>}
                          {day.EPAYMENT > 0 && <span>📱 Online: ₹{day.EPAYMENT.toLocaleString('en-IN')}</span>}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              {/* Week Summary */}

            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="monthly" className="mt-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-gray-900">Last 10 Months Sales</CardTitle>
            </CardHeader>
            <CardContent>
              {/* Simple Month-wise Sales */}
              <div className="space-y-3">
                {monthlySales.map((month, index) => {
              const dayTotal = month.CASH_AMOUNT + month.BTC_AMOUNT + month.CARD_AMOUNT + month.EPAYMENT + month.CHEQUE_AMOUNT;
              const percentage = maxWeeklySale > 0 ? (dayTotal / maxWeeklySale) * 100 : 0;
              const isCurrentMonth = month.DAY_NAME === moment().format("MMMM"); // Current day in your data
              
                  return (
                    <div key={month?.YEAR_MONTH} className={`p-4 rounded-lg border-2 ${isCurrentMonth ? 'border-blue-500 bg-blue-50' : 'border-gray-200 bg-white'}`}>
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-2">
                          <span className="text-gray-900">{month?.YEAR_MONTH}</span>
                        
                        </div>
                        <span className="text-gray-900">₹{dayTotal.toLocaleString('en-IN')}</span>
                      </div>
                      
                      {/* Visual Bar */}
                      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
                        <div 
                          className={`h-full rounded-full ${isCurrentMonth ? 'bg-blue-500' : 'bg-purple-500'}`}
                          style={{ width: `${percentage}%` }}
                        ></div>
                      </div>
                      {dayTotal > 0 && (
                        <div className="flex gap-4 mt-2 text-gray-600">
                          {month.CASH_AMOUNT > 0 && <span>💵 Cash: ₹{month.CASH_AMOUNT.toLocaleString('en-IN')}</span>}
                          {month.BTC_AMOUNT > 0 && <span>🏦 BTC: ₹{month.BTC_AMOUNT.toLocaleString('en-IN')}</span>}
                          {month.CARD_AMOUNT > 0 && <span>💳 Card: ₹{month.CARD_AMOUNT.toLocaleString('en-IN')}</span>}
                          {month.EPAYMENT > 0 && <span>📱 Online: ₹{month.EPAYMENT.toLocaleString('en-IN')}</span>}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

          
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {/* Recent Purchases */}
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="text-gray-900 flex items-center gap-2">
              <FileText className="w-5 h-5" />
              Recent Purchases
            </CardTitle>
            <span className="text-gray-600">Total: ₹{purchaseTotal.toLocaleString('en-IN')}</span>
          </div>
        </CardHeader>
        <CardContent>
          {/* Desktop View */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-4 py-3 text-left text-gray-700">Invoice No</th>
                  <th className="px-4 py-3 text-left text-gray-700">Date</th>
                  <th className="px-4 py-3 text-right text-gray-700">Total</th>
                  <th className="px-4 py-3 text-right text-gray-700">Discount</th>
                  <th className="px-4 py-3 text-right text-gray-700">Grand Total</th>
                  <th className="px-4 py-3 text-right text-gray-700">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {purchaseSummary.map((item) => (
                  <tr key={item.INVNO} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-gray-900">#{item.INVNO}</td>
                    <td className="px-4 py-3 text-gray-600">
                      {new Date(item.DATE).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                    </td>
                    <td className="px-4 py-3 text-right text-gray-900">₹{item.TOTAL.toLocaleString('en-IN')}</td>
                    <td className="px-4 py-3 text-right text-orange-600">-₹{item.DISQ_AMT.toLocaleString('en-IN')}</td>
                    <td className="px-4 py-3 text-right text-gray-900">₹{item.GTOTAL.toLocaleString('en-IN')}</td>
                    <td onClick={() => {
                  getViewBillDetatils(item.INVNO)
                    }} className="px-4 cursor-pointer  py-3 text-right text-blue-500 ">View Bill</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <div className="md:hidden space-y-3">
            {purchaseSummary.map((item) => (
              <div key={item.INVNO} className="p-4 bg-gray-50 rounded-lg space-y-2">
                <div className="flex items-center justify-between">
                  <span className="text-gray-900">Invoice #{item.INVNO}</span>
                  <span className="text-gray-600">
                    {new Date(item.DATE).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}
                  </span>
                </div>
                <div className="grid grid-cols-3 gap-2 pt-2 border-t border-gray-200">
                  <div>
                    <p className="text-gray-600">Total</p>
                    <p className="text-gray-900">₹{item.TOTAL.toLocaleString('en-IN')}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Discount</p>
                    <p className="text-orange-600">-₹{item.DISQ_AMT.toLocaleString('en-IN')}</p>
                  </div>
                  <div>
                    <p className="text-gray-600">Final</p>
                    <p className="text-gray-900">₹{item.GTOTAL.toLocaleString('en-IN')}</p>
                  </div>
                </div>
                <Button onClick={() => {
                       getViewBillDetatils(item.INVNO)
                }} >
                  View Bill
                </Button>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
      {BillModal(isDialogOpen, setIsDialogOpen, itemList)}
      <SpinnerLoading />

    </div>
  );
}